"use client";
import React from 'react';
import './FormDocumentation.css';
import PropTypes from 'prop-types';
import { Icon, Input } from 'atm-global-stylish';
import { isEmpty, showModal } from '../../utils/functions';

const acceptImg = ".png, .jpg, .jpeg, .pdf, .doc, .docx";

const FormVehicular = ({ photos, setPhotos, errors, optional, maxSize }) => {
	return (
		<div className='flex flex-col w-full items-center justify-center gap-5'>
			<div className='flex flex-col w-full justify-between gap-3 my-4'>
				<p className='text-xl text-red font-semibold text-center'>
					Toda la documentacion requerida es obligatoria
				</p>
				<p className='text-center font-normal text-base mb-8'>Archivos admitidos son: .png, .jpg, .jpeg, .pdf, .doc, .docx</p>
				<div className='w-full flex-col flex gap-5 md:gap-8 items-center justify-center'>
					<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
						<FileInput maxSize={maxSize} label={"DNI FRENTE *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_dni_front: e
						}))} value={photos.photo_dni_front} error={errors.photo_dni_front} required className='mb-5 md:mb-0'
						/>
						<FileInput maxSize={maxSize} label={"DENUNCIA DE SINIESTRO *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_sinister_complaint: e
						}))} value={photos.photo_sinister_complaint} error={errors.photo_sinister_complaint} required />
					</div>
					<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
						<FileInput maxSize={maxSize} label={"DNI DORSO *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_dni_back: e
						}))} value={photos.photo_dni_back} error={errors.photo_dni_back} required className='mb-5 md:mb-0' />
						<FileInput maxSize={maxSize} label={"PRESUPUESTO DE REPARACION *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_invoice_for_repairments: e
						}))} value={photos.photo_invoice_for_repairments} error={errors.photo_invoice_for_repairments} required />
					</div>
					<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
						<FileInput maxSize={maxSize} label={"CEDULA VERDE FRENTE *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_green_front: e
						}))} value={photos.photo_green_front} error={errors.photo_green_front} required className='mb-5 md:mb-0' />
						<FileInput maxSize={maxSize} label={"REGISTRO DE CONDUCIR FRENTE *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_driver_license_front: e
						}))} value={photos.photo_driver_license_front} error={errors.photo_driver_license_front} required />
					</div>
					<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
						<FileInput maxSize={maxSize} label={"CEDULA VERDE DORSO *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_green_back: e
						}))} value={photos.photo_green_back} error={errors.photo_green_back} required className='mb-5 md:mb-0' />
						<FileInput maxSize={maxSize} label={"REGISTRO DE CONDUCIR DORSO *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_driver_license_back: e
						}))} value={photos.photo_driver_license_back} error={errors.photo_driver_license_back} required />
					</div>
					<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
						<FileInput maxSize={maxSize} label={"CERTIFICADO DE COBERTURA *"} setFile={(e) => setPhotos(prev => ({
							...prev,
							photo_coverage_certification: e
						}))} value={photos.photo_coverage_certification} error={errors.photo_coverage_certification} required className='mb-5 md:mb-0' />
						<FileInput maxSize={maxSize} label={"FOTO 1 *"} setFile={(file) => setPhotos(prev => ({
							...prev,
							photo_additional_1: file
						}))} value={photos.photo_additional_1} error={errors.photo_additional_1} required />
					</div>
					<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
						<FileInput maxSize={maxSize} label={"FOTO 2 *"} setFile={(file) => setPhotos(prev => ({
							...prev,
							photo_additional_2: file
						}))} value={photos.photo_additional_2} error={errors.photo_additional_2} required className='mb-5 md:mb-0' />
						<FileInput maxSize={maxSize} label={"FOTO 3 *"} setFile={(file) => setPhotos(prev => ({
							...prev,
							photo_additional_3: file
						}))} value={photos.photo_additional_3} error={errors.photo_additional_3} required />
					</div>
					<div className='flex flex-col md:flex-row w-full items-center justify-center md:gap-12'>
						<FileInput maxSize={maxSize} label={"FOTO 4 *"} setFile={(file) => setPhotos(prev => ({
							...prev,
							photo_additional_4: file
						}))} value={photos.photo_additional_4} error={errors.photo_additional_4} required className='mb-5 md:mb-0' />
						<FileInput maxSize={maxSize} label={"FOTO 5 *"} setFile={(file) => setPhotos(prev => ({
							...prev,
							photo_additional_5: file
						}))} value={photos.photo_additional_5} error={errors.photo_additional_5} required />
					</div>
				</div>
			</div>
		</div>
	);
};

const FileInput = ({ label, setFile, value, error, required = false, className = '', maxSize }) => {
	const handleChange = (e) => {
		const file = e?.target?.files[0] ?? null;
		if (file) {
			if (!['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(file.type)) {
				setFile(null);
				showModal('', 'El formato de archivo no es válido');
			} else {
				setFile(file);
			}
		}
	}

	return (
		<div className="flex flex-row w-full">
			<Input
				type='file'
				label={label}
				handleChange={handleChange}
				accept={acceptImg}
				inputIcon={value ? <Icon.DoubleCheck size={25} color={'#7C1338'} /> : <Icon.PlusCircle size={25} color={'#7C1338'} />}
				required={required}
				className={`${className} ${error ? 'text-shiny-pink' : ''} overflow-hidden text-ellipsis text-nowrap`}
				withRemoveButton={required === false}
				maxSize={maxSize}
			/>
		</div>
	);
}

FormVehicular.propTypes = {
	setPhotos: PropTypes.func.isRequired,
	photos: PropTypes.object.isRequired,
	errors: PropTypes.object.isRequired,
	optional: PropTypes.bool,
};

export default FormVehicular;